import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly unexpectedApiErrorMessage =
    'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists.';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status == 500) { // NOSONAR
          const normalizedError = new HttpErrorResponse({
            ...error,
            error: {
              ...(typeof error?.error == 'object' && error?.error ? error.error : {}),
              message: this.unexpectedApiErrorMessage,
            },
            status: 500,
            statusText: 'Internal Server Error',
          });
          return throwError(() => normalizedError);
        }

        return throwError(() => error);
      })
    );
  }
}
